module.exports = __webpack_public_path__ + "img/symbol_8.f1c27983.png";